'use strict';

exports.__esModule = true;
exports.default = {
  nav: {
    mmp: '商户管理后台',
    index: '首页概览',
    settlement: '清算管理',
    tradeMng: '交易管理',
    tradeAssign: '交易流水',
    refundCheck: '退款审核',
    shopMng: '账户信息',
    cashMng: '收银员管理',
    setup: '设置',
    passSet: '管理密码设置',
    emailSet: '邮箱设置',
    contact: '客服',
    termsAndEnquiries: '条款及客服',
    terms: '条款与细则',
    termsContent: '使用QFPay支付服务，即表示您同意以下链接内的条款。如果您不同意本条款，则不得使用QFPay支付服务。',
    termsLink: 'http://merchanttnc.s3-website-ap-southeast-1.amazonaws.com/',
    device: '设备绑定',
    partnerAccountSetting: 'Partner Account',
    functionSettings: '功能设置',
    remotePay: 'RemotePay',
    linkManage: '链接管理',
    orderManage: '订单管理'
  },
  common: {
    ok: '确 定',
    cancel: '取 消',
    close: '关 闭',
    confirm: '确 认',
    tip: '提示',
    all: '全部',
    none: '无',
    netError: '网络错误',
    loading: '拼命加载中',
    modSucc: '修改成功',
    modFailed: '修改失败',
    logout: '退出',
    del: '删除',
    export: '导出',
    msg: {
      sel: '请选择'
    }
  },
  time: {
    today: '今天 ',
    yesterday: '昨天',
    near7: '近7天',
    near30: '近30天',
    nearMonth: '上月',
    nearDay: '本月',
    near365: '近一年',
  },
  main: {
    bigMerchant: '企业',
    merchant: '单店',
    subMerchant: '分店',
    cashier: '收银员'
  },
  shopmng: { // 门店管理模块
    crumbs: {
      L1: '账户信息'
    },
    title: {
      baseInfo: '基本信息',
      subInfo: '分店信息'
    },
    panel: {
      shopName: '商户名称',
      loginAccount: '登录账号',
      mID: 'MID',
      btn: {
        editPwd: '修改密码',
        editSub: '编辑分店',
        editSubTag: '编辑分店编号',
        down: '下载店铺收款码',
        listDown: '下载分店收款码'
      },
      table: {
        subName: '分店名称',
        loginAccount: '登录账号',
        regTime: '注册时间',
        sID: 'SID',
        subTag: '分店编号',
        op: '操作',
        detail: '查看详情',
        more: '更多',
        editPwd: '修改密码',
        delSub: '删除分店'
      }
    },
    dialog: {
      editPwd: '修改密码',
      loginAccount: '登录账号',
      inputNewPwd: '输入新密码',
      confirmNewPwd: '确认新密码',
      msg: {
        m1: '请输入新密码',
        m2: '请输入确认新密码',
        m3: '新密码与确认密码不一致',
        m4: '请输入6~20位数字或字母',
        m5: '请输入总账户密码',
        m6: '请输入分店账号',
        m7: '请输入分店登录密码',
        m8: '请输入分店收款人姓名!',
        m9: '请输入分店收款银行卡号!',
        m10: '请输入二十以内的文字或字母',
        m11: '不能含有特殊字符',
        m12: '密码不正确',
        m13: '删除分店成功!'
      },
      cancel: '取消',
      ok: '确定',
      confirm: '确认',
      shopDetail: '门店详情',
      shopName: '店铺名称',
      address: '地址',
      mobile: '手机号',
      cardHolder: '持卡人',
      bankAccount: '银行账户',
      bankName: '银行名称',
      editSubTag: '编辑分店编号',
      diaTip: '分店编号设置成功后将会显示在下载的交易明细和交易汇总中',
      validateText: '请输入二十位以内的文字或字母',
      validateText2: '请输入总账户登录密码',
      notice: '提示',
      noticeTip: '删除分店前建议先终止该分店正在进行的会员营销活动。',
      downTip: '选择需要下载收款码的分店名称：',
      nullTip: '请至少选择一家分店',
      all: '全选'
    }
  },
  tradeMng: { // 交易流水
    crumbs: {
      L1: '交易管理',
      L2: '交易详情',
      L3: '退款详情',
      L4: '交易流水'
    },
    panel: {
      time: '时间',
      range: '选择日期范围',
      shopName: '店铺名称',
      operator: '操作账号',
      moreFilter: '更多筛选',
      noLimit: '不限',
      dd: '撤销明细', // 撤销明细
      sNum: '流水号', // 流水号
      tip: '请输入流水号',
      tip1: '请输入店铺名称',
      chnlsn: '外部订单号',
      lastevent: '最新活动',
      cardScheme: '卡交易',
      btn: {
        query: '查询',
        advancedSearch: '高级搜索',
        reset: '重置'
      }
    },
    table: {
      totalAmount: '交易总金额',
      totalNum: '交易总笔数',
      succAmount: '成功交易金额',
      succ: '成功交易笔数',
      refundMount: '退款金额',
      refundNum: '退款笔数',
      bi: '笔',
      undo: '撤销明细',
      shopName: '店铺名称',
      operator: '操作账号',
      all: '全部',
      main: '门店主账户',
      colWay: '收款方式',
      wechatCollect: '微信收款',
      alipay: '支付宝收款',
      tradeType: '交易类型',
      tradeTime: '交易时间',
      tradeAmount: '订单金额',
      originAmount: '应收',
      currency: '币种',
      tradeState: '交易状态',
      redpacket: '红包优惠',
      sNum: '流水号',
      chnlsn: '外部订单号',
      merchantOrder: '商户订单号',
      customerId: '消费者ID',
      src: '消费者来源',
      cardCd: '银行卡号',
      remark: '备注',
      op: '操作',
      cancel: '退款',
      down: '下载',
      more: '更多',
      detail: '查看详情',
      download: '下载小票',
      ac: '实收', // 实收
      red: '商家红包', // 商家红包
      plat: '平台补贴', // 平台补贴
      cardNumber: '卡号',
      cardScheme: '卡组织',
      cardType: '卡类型',
      cardArea: '卡地区',
      btn: {
        downDetail: '下载交易明细',
        downTrade: '下载交易汇总'
      },
      tip: {
        m1: 'QFPay生成的订单号',
        m2: '收单机构 (如支付宝/微信支付/银联云闪付等) 生成的订单号',
        m3: '商户内部系统生成的自定号码 (如适用)',
        m4: '搜索范围内, 成功收款的总金额 (未扣除退款)',
        m5: '搜索范围内, 成功收款的总笔数 (未扣除退款)',
        m6: '搜索范围内, 退款订单的总金额',
        m7: '搜索范围内, 退款订单的总笔数'
      }
    },
    detail: {
      amount1: '订单金额',
      amount2: '退款金额',
      origin: '消费者来源',
      time: '退款时间',
      syssn1: '订单流水号',
      syssn2: '原订单流水号',
      syssn3: '退款流水号',
      store: '交易门店',
      account: '操作账户',
      refundApplicationSource: '退款申请来源',
      history: '退款历史',
      amount3: '实收金额',
      count1: '实收币数',
      count2: '订单币数',
      syssn4: '区块链订单号'
    },
    dialog: {
      d1: '操作一旦确认将无法撤回，是否确认？',
      d2: '确认退款',
      d3: '成功',
      d4: '失败',
      d5: '密码',
      d6: '退款',
      d7: '退款中',
      d8: '隔日退款申请',
      d9: '提交审批',
      refundAmount: '退款金额:',
      approvalType: '交易类型:',
    },
    msg: {
      m1: '流水号必须为数字',
      m2: '交易流水号需要至少14位！',
      m3: '首次获取交易列表失败',
      m4: '获取交易数据失败',
      m5: '获取收银员信息失败',
      m6: '撤销成功',
      m7: '撤销失败',
      m8: '请输入流水号',
      m9: '请输入账户密码',
      m10: '密码不正确',
      m11: '您暂无权限执行此操作',
      m12: '超出可退范围',
      m13: '发起退款失败，请联系客服查询失败原因，或采用其他方式给消费者退款',
      m14: '最大可退款金额',
      m15: '请输入退款金额',
      m16: '请输入有效退款金额',
      m17: '请输入外部订单号',
      m18: '请输入商户订单号'
    }
  },
  refundCheck: { // 退款审核
    crumbs: {
      L1: '交易管理',
      L2: '退款审核'
    },
    panel: {
      time: '申请时间',
      shopName: '交易门店',
      operator: '操作账号',
      oNUm: '原订单流水号',
      tip: '请输入原订单流水号',
      btn: {
        query: '查询',
        reset: '重置'
      }
    },
    table: {
      applyAmount: '申请账户',
      tradeType: '交易类型',
      tradeTime: '交易时间',
      refundMount: '退款金额',
      tradeAmount: '订单金额',
      sNum: '流水号',
      checkState: '审核状态',
      waiting: '等待审核',
      underReview: '审核中',
      approved: '审核通过',
      rejected: '审核拒绝',
      refundSuccessfully: '退款成功',
      refundFailed: '退款失败',
      refundInProgress: '退款中',
      op: '操作',
      approve: '批准',
      reject: '拒绝',
      refundApplicationSource: '退款申请来源',
      ims: '钱方管理平台',
      mms: '商户管理平台',
      haoJin: 'Hao jin客户端'
    },
    dialog: {
      d1: '操作一旦确认将无法撤回，是否确认批准？',
      d2: '操作一旦确认将无法撤回，是否确认拒绝？',
      d3: '确认批准',
      d4: '确认拒绝'
    },
    msg: {
      m1: '管理密码',
      m2: '请输入管理密码',
      m3: '操作成功',
      m4: '退款操作成功，等待支付通道处理中。'
    }
  },
  home: { // 首页概览
    crumbs: {
      L1: '首页概览'
    },
    title: {
      t1: '交易数据统计',
      t2: '交易走势图'
    },
    panel: {
      t1: '今日会员新增',
      t2: '今日交易金额',
      tc: '今日回头客',
      cmnew: '本月会员新增',
      cumulativeMembership: '累计会员数',
      tta: '今日交易笔数',
      tincome: '今日实收',
      cmincome: '本月实收',
      noActivity: '暂无活动'
    },
    chart: {
      bill: '笔数',
      noTrans: '暂无交易',
      account: '实收',
      time: '时间',
      sum: '金额',
      tp1: '暂仅支持查询 30 天内的走势'
    }
  },
  settlement: { // 清算管理
    crumbs: {
      L1: '清算管理'
    },
    panel: {
      time: '时间',
      type: '类型',
      btn: {
        query: '查询',
        reset: '重置',
        downAll: '下载全部'
      }
    },
    table: {
      settleTime: '清算日期',
      settleType: '清算类型',
      name: '账号',
      amount: '开户名',
      currency: '币种',
      total: '交易总额',
      charge: '交易手续费',
      settleAmount: '清算金额',
      op: '操作',
      download: '下载',
      paymentFee: '交易通道费',
      refundFee: '退款服务费',
      chargebackFee: '拒付手续费',
      adjustmentFee: '调单金额'
    },
    msg: {
      m1: '获取清算数据失败',
      m2: '目前仅支持查询30天内的数据',
      m3: '暂无数据可以下载',
      m4: '暂无清算数据'
    },
    tip: {
      m1: '交易手续费是按照每笔订单乘以费率再进行四舍五入相加后得出'
    }
  },
  login: { // 登录页
    head: '商户管理后台',
    reg: '注册账号',
    user: '主账号',
    cash: '收银员编号',
    ltsix: '6位以上',
    login: '登录',
    forgetPwd: '忘记密码?',
    tab1: '商户',
    tab2: '收银员',
    msg: {
      m1: '请输入账号',
      m2: '请输入密码',
      m3: '登录失败',
      m4: '请输入主账号',
      m5: '请输入收银员编号',
      m6: '未发现此账号'
    }
  },
  setting: { // 设置
    crumbs: {
      L1: '设置',
      L2: '邮箱设置',
      L3: '设备绑定',
      L4: '功能设置',
      L5: 'Partner Account'
    },
    form: {
      account: 'QF Store ID:',
      gateway: 'Payment Gateway:',
      clientID: 'Client ID:',
      clientSecret: 'Client Secret:',
      signingKeyID: 'Signing Key ID:',
      signingKey: 'Signing Key:',
      expiresDate: '过期日期:',
      expiresMsg: '*当 Key 文件即将过期时，我们会给你们的联络邮箱地址发送过期提示，提醒您及时更新最新的 Key 文件。',
      shopifyDefaultDomain: 'Shopify 默认域名:',
      apiCredential: 'API 凭证:',
      example: '例子: *.myshopify.com',
      howToGet: '获取路径: 登录Shopify账号，到 设定 > 应用程式和稍售管道。',
    },
    gatewayList: {
      online: 'PayMe HSBC online',
      offline: 'PayMe HSBC offline',
      customApp: 'Shopify-Payment Custom Checkout',
    },
    panel: {
      mailSetup: '邮箱设置',
      mail: '邮箱',
      explain: '我们会在次日早上7点，把上一天的交易记录发送给您。',
      dailySend: '每日发送交易报表',
      modi: '修改',
      confirm: '确认',
      amount: '门店账号',
      device: '设备编号'
    },
    btn: {
      query: '查询',
      reset: '重置',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit'
    },
    table: {
      merchant: '大商户名称',
      shopName: '店铺名称',
      time: '绑定时间',
      close: '解绑',
      functionName: '功能名称',
      note: '描述',
      status: '状态',
      functionNameCont: '商户后台交易流水页的退款功能',
      noteCont: '关掉该功能，本商户下所有门店在商户后台均不能通过交易流水页面的「退款」的功能进行退款；相反开启本功能，本商户下所有门店均能在交易当天通过交易流水页面的「退款」功能进行退款。'
    },
    dialog: {
      d1: '添加设备',
      d2: '解绑设备',
      d3: '是否确认关闭',
      d4: '是否确认开启',
      d5: '确定',
      d6: '取消',
      d7: '您确定要关闭商户后台流水页面的「退款」功能吗？',
      d8: '您确定要开启商户后台流水页面的「退款」功能吗？'
    },
    msg: {
      m1: '请输入邮箱地址',
      m2: '请输入正确的邮箱地址',
      m3: '获取邮箱设置失败!',
      m5: '已经添加过这个邮箱了!',
      m6: '最多只能添加10个邮箱',
      m7: '是否确认解绑',
      m8: '解绑成功',
      m9: '请输入门店账号',
      m10: '请输入设备编号',
      m11: '添加成功',
      m12: 'On processing.',
      m13: 'Submit success. On processing',
      m14: 'Please input client ID',
      m15: 'Please input client secret',
      m16: 'Please input signing key ID',
      m17: 'Please input signing key',
      m18: 'please select payment gateway',
      m19: 'please input QF store ID',
      m20: '请选择过期日期',
      m21: '请输入 Shopify 的默认域名',
      m22: '请输入 API 凭证',
    },
    tip: {
      m1: '删除最后一个邮箱会关掉邮件报表的功能，确认删除吗？'
    }
  },
  passSet: { // 管理密码设置
    crumbs: {
      L1: '设置',
      L2: '管理密码设置'
    },
    panel: {
      passMsg: '管理密码：',
      explain: '用途：设置后，隔日退款审批 将通过输入管理密码完成确认验证。',
      states1: '未设置',
      states2: '已设置',
      bt1: '设置',
      bt2: '重置',
      bt3: '保存',
      title1: '设置管理密码',
      title2: '重置管理密码',
      safe: '安全验证',
      pass: '管理密码',
      reEnter: '再次输入',
      originPass: '原管理密码',
      newPass: '新管理密码'
    },
    msg: {
      m1: '请输入登录密码',
      m2: '请输入管理密码',
      m3: '请再次输入管理密码',
      m4: '请输入6～20 位数字或字母',
      m6: '请输入原管理密码',
      m7: '请输入新管理密码',
      m8: '请再次输入新管理密码',
      m9: '与管理密码输入不一致',
      m10: '设置成功'
    },
    tip: {
      m1: '忘记了原管理密码？'
    }
  },
  cashMng: { // 收银员管理
    crumbs: {
      L1: '收银员管理',
      L2: '查看详情',
      L3: '添加收银员',
      L4: '批量添加'
    },
    common: {
      status: '账户状态',
      number: '收银员编号',
      name: '姓名',
      mobile: '电话',
      shop: '门店',
      user: '主账号',
      password: '收银员密码',
      m1: '账户已禁用',
      m2: '账户已启用',
      m5: '请输入收银员姓名',
      m6: '请输入收银员电话',
      m7: '请输入收银员密码',
      m8: '请输入2~20位字符',
      m9: '请输入正确的收银员电话',
      m10: '请输入6~20位字符',
      tip1: '* 收银员登陆方式为主账号+收银员编号+收银员密码'
    },
    dialog: {
      title: '批量添加收银员',
      d1: '请选择收银员的表单文件',
      d2: '选择文件',
      d3: '上传',
      d4: '下载模板',
      d5: '上传成功'
    },
    mng: {
      status1: '已启用',
      status2: '已禁用',
      status3: '启用账户',
      status4: '禁用账户',
      name: '收银员名称',
      mobile: '收银员电话',
      op: '操作',
      detail: '查看详情',
      m5: '获取收银员数据失败',
      open: '开',
      close: '关',
      isOpenR: '已开通Remotepay',
      isCloseR: '已关闭Remotepay',
    },
    detail: {
      title: '收银员资料',
      btn: '编辑收银员资料'
    },
    add: {
      title: '输入收银员信息',
      tip1: '添加收银员成功',
      tip2: '获取收银员编号失败',
      btn1: '放弃添加',
      btn2: '提交'
    }
  },
  contact: { // 客服
    phone: '电话',
    email: '邮箱'
  },
  remote: {
    crumbs: {
      L1: 'RemotePay',
      L2: '订单列表',
      L3: '生成链接',
    },
    panel: {
      title: '生成链接',
      shareGuide: '分享引导'
    },
    form: {
      productName: '商品名称',
      quantity: '数量',
      currency: '币种',
      hkd: '港币',
      price: '单价',
      add: '添加',
      delete: '删除',
      totalAmount: '总价',
      customerName: '客户姓名',
      customerPhone: '客户电话',
      phone_font: '为了保障资金的风险，建议输入客户的手机号码，以免遇到资金问题时无法联系到客户。',
      customerEmail: '客户邮箱',
      paymentDeadline: '付款截止日期',
      logisticsMode: {
        title: '物流方式',
        option1: '送货或自取',
        option2: '送货',
        option3: '自取',
        option4: '无物流',
      },
      date: '预期送货时间',
      description: '备注',
      writeDescription: '请输入备注'
    },
    rules: {
      customerPhoneMessage: '请输入正确格式：区号-电话号码',
      invalidEmail: '无效的邮箱格式',
      logisticsModeMsg: '请选择物流方式',
      quantityRules: '请输入数量',
      quantityFormat: '请输入数字',
      unitPriceRules: '请输入单价',
      productMessage: '请添加商品信息',
      otherValidMessage: '不可输入特殊字符'
    },
    btn: {
      cancel: '取消',
      link: '生成链接'
    }
  },
  remoteDone: {
    crumbs: {
      L1: 'RemotePay',
      L2: '链接管理',
      L3: '生成结果'
    },
    panel: {
      title: '支付链接'
    },
    msg: {
      title: '支付链接',
      send: '发送',
      cancel: '取消',
      copy: '复制',
      confirm: '确认',
      shareMessageLeft: '尊敬的客户，您好！',
      shareMessageRight: '店铺向您发出了购买邀请，请您及时支付，谢谢！',
      Email: '邮箱',
      copyLink: '复制链接',
      copySuccess: '复制成功',
      copyFail: '复制失败',
      promptEmail: '邮件地址未填写',
      promptMobile: '电话号码未填写',
      sent: '已发送'
    },
    transaction: {
      title: '链接详情'
    },
    table: {
      productName: '商品名称',
      quantity: '数量',
      currency: '币种',
      price: '单价',
      totalAmount: '总价',
      customerName: '客户姓名',
      customerPhone: '客户电话',
      customerEmail: '客户邮箱',
      paymentDeadline: '付款截止日期',
      logisticsMode: '物流方式',
      date: '预期送货时间',
      description: '备注'
    }
  },
  apply: {
    apply: '申请',
    applyed: '已申请',
    title: '什么是remotepay',
    list1: '商户创建购买邀请链接',
    list2: '商户通过即时通讯软件等方式发送链接给顾客',
    list3: '顾客支付',
    list4: '顾客选择物流方式（送货/自取）',
    list5: '顾客得到商品',
    howtoApply: '如何申请remotepay',
    method1: '提交申请',
    method2: '确认产品开通联系邮件/电话',
    method3: '开通产品',
    method4: '登录平台使用产品',
    remotePayMsg1: '您可以将付款链接在',
    remotePayMsg2: '任何时间，',
    remotePayMsg4: '任何地点，',
    remotePayMsg6: '发送给',
    remotePayMsg7: '任何人，',
    remotePayMsg9: '客户可以付款来完成他们的购买。'
  },
  linkManage: {
    title: '链接管理',
    filter: '搜索',
    mon: '星期一',
    tue: '星期二',
    wed: '星期三',
    thu: '星期四',
    fri: '星期五',
    sat: '星期六',
    sun: '星期日',
    noData: '暂无链接数据',
    btn: {
      oneMore: '再发一单',
      cancel: '取消',
      generateLinks: '生成链接',
      createLink: '创建链接'
    },
    filterSe: {
      title: '搜索',
      goodsName: '商品名称',
      createTime: '创建时间',
      status: '状态',
      creatorID: '创建者ID',
      customerName: '客户姓名',
      customerPhone: '客户电话',
      all: '全部',
      pending: '待付款',
      canceled: '已取消',
      overdue: '已逾期',
      Success: '已付款',
      fail: '付款失败',
      fullRefund: '已退款',
      partialRefund: '部分退款',
      confirm: '确认',
      paymentFailed: '付款失败',
      partialRefunded: '部分退款'
    },
    detail: {
      title: '详情',
      delete: '删除',
      linkId: '链接ID:',
      link: '支付链接:',
      goodsName: '商品名称:',
      cId: '创建者ID:',
      status: '状态:',
      time: '创建时间:',
      cancel: '取消',
      oneMore: '再发一单',
      paymentDeadline: '付款截止日期:',
      confirmCancel: '确认取消',
      confirmDelete: '确认删除',
      deleteMsg: '您确定要删除该链接吗？删除后，该链接便不能再进行支付以及不会显示出来~',
      cancelMsg: '您确定要取消该链接吗？取消之后，该链接便不能再进行支付！'
    }
  },
  orderManage: {
    detail: '订单详情',
    details: '详情',
    title: '订单管理',
    noData: '暂无订单数据',
    delevery: '发货',
    total: '总计',
    unpaidAmount: '未付金额',
    totalAmount: '合计金额',
    successAmount: '成功金额',
    failedAmount: '失败金额',
    fullRefundAmount: '全额退款金额',
    partialRefundAmount: '部分退款金额',
    number: '笔数',
    unpaidNumber: '未付笔数',
    successNumber: '成功笔数',
    failedNumber: '失败笔数',
    fullRefundNumber: '全额退款笔数',
    partialRefundNumber: '部分退款笔数',
    entries: '笔',
    confirmDelivery: '确认发货',
    expressCompany: '快递公司',
    expressNumber: '快递单号',
    confirm: '确认',
    cancel: '取消',
    deliveryMsg: '您确定要将该链接的送货状态修改为“已发货”吗？可以在下方备注发送的快递公司和快递单号哦~',
    deliveFormat: '请输入正确格式的快递单号',
    filter: {
      title: '搜索',
      mchtOrderId: '商户订单号',
      payOrderId: '支付订单号',
      linkId: '链接ID',
      customerName: '客户姓名',
      deliveryStatus: '送货状态',
      noDelivery: '无需送货',
      notdelivered: '未发货',
      delivered: '已发货'
    }
  },
  orderEdit: {
    title: '订单编辑',
    edit: '编辑',
    productTitle: '商品信息',
    buyerTitle: '买家信息',
    expressTitle: '物流信息',
    description: '备注',
    customerAdress: '客户地址',
    confirm: '确认'
  },
  orderDetail: {
    title: '详情',
    mchtOrderId: '商户订单号',
    payOrderId: '支付订单号',
    linkId: '链接ID',
    transactionStatus: '订单状态',
    paymentlink: '支付链接',
    createTime: '创建时间',
    expectedDeliveryTime: '预期送货时间',
    productTitle: '商品信息',
    quantity: '数量',
    currency: '币种',
    hkd: '港币',
    price: '单价',
    totalAmount: '总价',
    deliveryStatus: '送货状态',
    buyerTitle: '买家信息',
    customerName: '客户姓名',
    customerPhone: '客户电话',
    customerEmail: '客户邮箱',
    customerAdress: '客户地址',
    expressTitle: '物流信息',
    logisticsMode: '物流方式',
    description: '备注',
    expressCompany: '快递公司',
    expressNumber: '快递单号'
  },
  uploadMessage: {
    fileSize: '请上传不超过100M的jpg、png、jpeg格式的图片',
    uploadNow: '立即上传',
    uploadFail: '上传失败'
  },
  overseaForget: {
    enterEmail: '请输入您的邮箱',
    enterFullEmail: '请输入下面完整的邮箱地址',
    emailAddr: '邮箱地址',
    loginAccount: '登录账号',
    enterAccount: '请输入您的登录账号',
    tryAnother: '试试其他方法',
    next: '下一步',
    confirm: '确认',
    notExist: '该账号未注册，请确认您邮箱是否正确',
    sendCode: '我们会给您的邮箱发送验证码,请输入验证码',
    resend: '重新发送',
    code: '验证码',
    newPwd: '新密码',
    enterCode: '请输入验证码',
    char: '密码需要6~20位之间',
    rePwd: '重置密码',
    invalidEmail: '无效的邮箱格式',
    text1: '我们会给',
    text2: '发送验证码，请输入验证码',
    secend1: "( ",
    secend2: 's )后可以重发',
    codeResent: '验证码发送成功',
    wrongCode: '验证验证码失败',
    filledCode: '验证码不能为空',
    frequently: '验证码获取频繁',
    newManagementPassword: '新管理密码',
    confirmManagementPassword: '确认管理密码',
    msg: {
      m1: `发现你还没有设置联系邮箱地址。`,
      m2: '请联系我们的客服团队完成邮箱的设置，再进行管理密码重置操作。',
      m3: '请输入新的管理密码',
      m4: '请再次输入新的管理密码',
    },
  },
  firstlogin: {
    congratulation: '恭喜您登录成功',
    changePwd: '请修改您的初始密码',
    newPwd: '新密码',
    rePwd: '确认密码',
    confirm: '确 认'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js